import React from 'react'
import { Box, Link } from '@ally/metronome-ui'
import { InvestWidgetContent } from '../../../types'
import { setLinkTarget } from '../../../utils'

const WidgetFooter: React.FC<{ data: InvestWidgetContent }> = ({ data }) => {
  const { ctaLabel, ctaHref, ctaNewTab } = data

  return (
    <>
      {ctaLabel && ctaHref && (
        <Box textAlign="right" p="sm">
          <Link
            text={`${ctaLabel} »`}
            to={`${ctaHref}`}
            target={setLinkTarget(!!ctaNewTab)}
          />
        </Box>
      )}
    </>
  )
}

export default WidgetFooter
